module.exports = __webpack_public_path__ + "static/media/image_1.ff9e68dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureBlock/images/image_1.jpg
// module id = 846
// module chunks = 0